// TODO: вынести на верхний уровень
const isCurator = (window as any).isCurator;
// /TODO

import * as React from "react";
import { MobXProviderContext, observer } from "mobx-react";
import {
  Box,
  Divider,
  Grid,
  ListItemIcon,
  MenuList,
  MenuItem
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { MUIBlock, MUIProgressBar, MUISidebar, MUISelect } from "../../../MUI";
import { tl } from "../../../../../utils";
import * as styles from "./styles.scss";
import cx from "classnames";

import { SvgIcon } from "../../../../../components";
import FSStore from "../../store";
import FSCourseStore from "../store";

const viewsList = [
  { section: "notuse", tab: "all", label: tl("Загруженные файлы") },
  { section: "lessons", label: tl("Файлы в уроках") },
  {
    section: "notuse",
    tab: "notinlessons",
    label: tl("Неиспользуемые в уроках")
  },
  {},
  { section: "homeworks", tab: "all", label: tl("Файлы ДЗ. Ученика и автора") },
  { section: "chats", tab: "all", label: tl("Файлы чатов") }
];

export const RightPanel = observer(() => {
  const { fsStore, fsCourseStore } = React.useContext<{
    fsStore: FSStore;
    fsCourseStore: FSCourseStore;
  }>(MobXProviderContext);
  const theme = useTheme();

  const onChangeFilesType = (option: any) => {
    fsCourseStore.setFilterParams({ filestype: option.target.value });
  };

  const navList = viewsList.map((view: any) => {
    const item = view.label
      ? {
          label: view.label,
          selected:
            (fsCourseStore.filesSection === "notuse" &&
              fsCourseStore.filesSection === view.section &&
              fsCourseStore.filesSectionTab === view.tab) ||
            (fsCourseStore.filesSection !== "notuse" &&
              fsCourseStore.filesSection === view.section),
          onClick: () => {
            fsCourseStore.setFilesSectionAndTab(view.section, view.tab);
          }
        }
      : {};
    return item;
  });

  return (
    <MUISidebar navList={[navList]}>
      <Grid item xs={12} sm md={12}>
        <MUIBlock height="100%">
          <Box mb={1} color={theme.palette.grey[600]} fontWeight={600}>
            {tl("Тип и вид файлов")}
          </Box>
          <MUISelect
            value={fsCourseStore.filterFilesType}
            onChange={onChangeFilesType}
            variant="outlined"
            fullWidth
          >
            {fsCourseStore.filesTypesOptionsList.map(
              (option: { value: string; label: string }, i: number) => (
                <MenuItem key={`${i}_${option.value}`} value={option.value}>
                  {option.label}
                </MenuItem>
              )
            )}
          </MUISelect>
        </MUIBlock>
      </Grid>
      {!isCurator ? (
        <Grid item xs={12} sm md={12}>
          <MUIBlock height="100%">
            <Box mb={1} color={theme.palette.grey[600]}>
              <Grid container justifyContent="space-between" alignItems="center">
                <Box fontWeight={600} clone>
                  <Grid item>{tl("Занято")}</Grid>
                </Box>
                <Grid item>
                  {fsCourseStore.fsSpaceUsed} {tl("из")}{" "}
                  {fsCourseStore.fsSpaceTotal}
                </Grid>
              </Grid>
            </Box>
            <MUIProgressBar
              data={{
                variant: "determinate",
                value: fsCourseStore.fsSpacePercentage
              }}
            />
          </MUIBlock>
        </Grid>
      ) : null}
      {fsStore.canDelete && false ? (
        <Grid xs={12} sm md={12}>
          <MUIBlock height="100%">
            <MenuList>
              <MenuItem>
                <ListItemIcon>
                  <SvgIcon type="fs-trash" />
                </ListItemIcon>
                {tl("Удаление файлов")}
              </MenuItem>
            </MenuList>
          </MUIBlock>
        </Grid>
      ) : null}
    </MUISidebar>
  );
});
